import * as React from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { useStaticQuery, graphql } from 'gatsby'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

const BlogList = props => {
  const title = props.title
  const description = props.description
  const sectionClass = props.sectionClass
  const category = props.category

  const { allMdx } = useStaticQuery(graphql`
    query BlogList {
      allMdx(sort: { frontmatter: { modifyDate: DESC } }) {
        edges {
          node {
            id
            fields {
              slug
            }
            excerpt(pruneLength: 250)
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              modifyDate(formatString: "MMMM DD, YYYY")
              title
              categories
              featured {
                childImageSharp {
                  gatsbyImageData(width: 416)
                }
              }
            }
          }
        }
      }
    }
  `)

  const posts = allMdx.edges

  // console.log(posts)

  return (
    <>
      <section className={`blog-list-section section ${sectionClass}`}>
        <Container className='py-5'>
          <div className='w-75'>
            <div className='section-title mb-5 pb-1'>
              <h2 className='heading fw-semibold mb-4'>{title}</h2>
              <p className='lead'>{description}</p>
            </div>
          </div>
          <Row xs={1} lg={3} className='g-4'>
            {category
              ? posts
                .filter(edge =>
                  edge.node.frontmatter.categories?.some(i =>
                    category.includes(i)
                  )
                )
                .map(
                  (post, index) =>
                    index < 3 && (
                      <Col key={index}>
                        <Link
                          to={post.node.fields.slug}
                          className='blog-list-card single'
                        >
                          <div className='blog-image'>
                            <GatsbyImage
                              loading='lazy'
                              width={416}
                              height={250}
                              image={
                                post.node.frontmatter?.featured
                                  ?.childImageSharp.gatsbyImageData
                              }
                              alt='featured'
                            />
                          </div>
                          <div className='blog-list-content mt-4'>
                            <h2 className='blog-title fw-normal h4'>
                              {post.node.frontmatter.title}
                            </h2>
                          </div>
                        </Link>
                      </Col>
                    )
                )
              : posts.map(
                (post, index) =>
                  index < 3 && (
                    <Col key={index}>
                      <Link
                        to={post.node.fields.slug}
                        className='blog-list-card single'
                      >
                        <div className='blog-image'>
                          <GatsbyImage
                            loading='lazy'
                            width={416}
                            height={250}
                            image={
                              post.node.frontmatter?.featured?.childImageSharp
                                .gatsbyImageData
                            }
                            alt='featured'
                          />
                        </div>
                        <div className='blog-list-content mt-4'>
                          <h2 className='blog-title fw-normal h4'>
                            {post.node.frontmatter.title}
                          </h2>
                        </div>
                      </Link>
                    </Col>
                  )
              )}
          </Row>
          <div className='mt-4 text-center'>
            <Link to='/blog' className='btn btn-link mt-4'>
              <span>view more blogs</span>{' '}
              <i className='icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right'></i>
            </Link>
          </div>
        </Container>
      </section>
    </>
  )
}

BlogList.defaultProps = {
  title: 'Look through your eyes of insight to our insightful thoughts',
  description:
    'DigiPay.Guru is born to simplify financial transactions. We love discussing the latest finTech solutions. We write regular blogs where we cover insightful topics with our insightful thoughts to cater you with imperative informations.',
  sectionClass: 'bg-light'
}

export default BlogList
